import { Box, styled } from '../../base';

export const StyledApplyNowBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
}));

export const StyledApplyNowMiddleContainerBox = styled(Box)(({ theme }) => ({
    overflow: 'auto',
    maxHeight: '60vh',
    marginBottom: theme.spacing(2),
    paddingBlock: theme.spacing(1),
}));

export const StepConnector = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 20,
    insetInlineStart: 'calc(-50% + 20px)',
    insetInlineEnd: 'calc(50% + 20px)',
    height: 2,
    backgroundColor: theme.palette.primary.main,
    zIndex: 1,
}));
